<!-- 繳交文件設定 -->
<template>
	<div>
		<ListForm
			api="coopLoanProjectDoc"
			:id="id"
			labelPosition="top"
			formTitle="設定新方案與減免"
			:rules="rules"
			:recordToEdit="recordToEdit"
			:formType="formType"
			@calculateInfo="calculateInfo"
			@viewProject="viewProject"
			ref="list"
		>
			<div slot="iouCalculate">
				<el-form-item label="原方案名稱">{{
					recordToEdit.oldProjectName
				}}</el-form-item>
				<el-form-item label="原方案目前年利率"
					>{{ iouInfo.normalAnnualRate }}%</el-form-item
				>
				<el-form-item label="本金結餘">{{
					iouInfo.loanPriceBeforePay
				}}</el-form-item>
				<el-form-item label="應還利息">{{
					iouInfo.payBackInterest
				}}</el-form-item>
				<el-form-item label="應還違約金">{{
					iouInfo.payBackBreakPrice
				}}</el-form-item>
			</div>
			<div slot="footer">
				<el-button
					type="primary"
					v-if="recordToEdit.iouModifyStatus == 2"
					@click="submitProject()"
					>送出</el-button
				>
				<el-button @click="$refs.list.back()">關閉</el-button>
			</div>
		</ListForm>
		<el-dialog
			title="檢視方案"
			:visible.sync="dialogEdit"
			append-to-body
			:show-close="false"
			class="modal-show"
		>
			<el-form>
				<div>
					<el-form-item label="方案名稱">{{
						projectSelect.name
					}}</el-form-item>
					<el-form-item label="是否發放利息攤還">{{
						renderEnum(projectSelect.isPayYearStl, "booleanEunm")
					}}</el-form-item>
					<el-form-item label="方案類型">{{
						renderEnum(projectSelect.loanType, "loanType")
					}}</el-form-item>
					<el-form-item label="方案適用對象">{{
						renderEnum(
							projectSelect.loanObjects,
							"loanObjectType",
							true
						)
					}}</el-form-item>
					<el-form-item label="是否限制股金內放款">{{
						renderEnum(projectSelect.restrictInStock, "booleanEunm")
					}}</el-form-item>
					<el-form-item label="還款方式">{{
						renderEnum(
							projectSelect.normalPaymentType,
							"paymentType"
						)
					}}</el-form-item>
					<el-form-item label="正常還款年利率"
						>{{ projectSelect.normalAnnualRate }}%</el-form-item
					>
					<el-form-item label="是否有違約後方案">{{
						renderEnum(projectSelect.hasDefault, "booleanEunm")
					}}</el-form-item>
					<el-form-item label="違約年利率"
						>{{ projectSelect.defaultAnnualRate }}%</el-form-item
					>
					<el-form-item label="備註">{{
						projectSelect.memo
					}}</el-form-item>
					<el-form-item label="還款/放款科目">
						{{
							projectSelect.projectAccountTitle
								.capitalAccountTitle.code
						}}
						{{
							projectSelect.projectAccountTitle
								.capitalAccountTitle.name
						}}
					</el-form-item>
					<el-form-item label="繳息科目">
						{{
							projectSelect.projectAccountTitle
								.interestAccountTitleId.code
						}}
						{{
							projectSelect.projectAccountTitle
								.interestAccountTitleId.name
						}}
					</el-form-item>
					<el-form-item label="違約金科目">
						{{
							projectSelect.projectAccountTitle.ldAccountTitleId
								.code
						}}
						{{
							projectSelect.projectAccountTitle.ldAccountTitleId
								.name
						}}
					</el-form-item>
				</div>
			</el-form>
			<div slot="footer">
				<el-button @click="dialogEdit = false">關閉</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import ListForm from "@/components/ListForm.vue";
import Workbench from "@/components/Workbench";
import { API } from "@/assets/config";

export default {
	name: "loan_plan_change_project",
	components: {
		ListForm,
		Workbench,
	},
	props: {
		// 由父頁 LoanPlanChangeEdit 透過 router-view 帶入，子頁不再自行 getData
		parentRecord: {
			type: Object,
			default: () => ({}),
		},
		enumData: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			dialogEdit: false,
			allEnum: {},
			chooseProjectList: {},
			projectSelect: {
				projectAccountTitle: {
					capitalAccountTitle: { name: "" },
					interestAccountTitleId: { name: "" },
					ldAccountTitleId: { name: "" },
				},
			},
			id: this.$route.params.id == "new" ? 0 : this.$route.params.id,
			iouInfo: {},
			recordToEdit: {},
			toolbarIou: { addable: false, removeable: false, select: false },
			query: {
				action: "getRunningIou",
			},

			formType: [
				{
					label: "結算基準日",
					key: "calculateBaseDate",
					type: "date",
				},
				{
					button: "計算金額",
					type: "button",
					buttonType: "primary",
					buttonKey: "calculateInfo",
				},
				{
					type: "slot",
					slot: "iouCalculate",
					vif: false,
				},
				{
					label: "選擇方案",
					key: "newProjectCode",
					type: "select",
					options: [],
				},
				{
					button: "檢視方案",
					type: "button",
					buttonType: "primary",
					buttonKey: "viewProject",
				},
				{
					label: "新方案目前年利率",
					key: "newProjectRate",
					type: "input",
					disabled: true,
				},
				{
					label: "利息減免金額",
					key: "interestAmountReduction",
					type: "number",
				},
				{
					label: "違約金減免金額",
					key: "annualAmountReduction",
					type: "number",
				},
			],
			rules: {
				name: [
					{ required: true, message: "請輸入姓名", trigger: "blur" },
				],
			},
		};
	},
	created() {
		this.bindData();
	},
	watch: {
		enumData: {
			handler() {
				this.bindData();
			},
			deep: true,
		},
		parentRecord: {
			handler() {
				this.bindData();
			},
			deep: true,
		},
		"recordToEdit.newProjectCode": {
			handler(NewVal) {
				this.projectSelect = this.chooseProjectList[this.recordToEdit.newProjectCode];
				this.projectSelect = !this.projectSelect
					? {
							projectAccountTitle: {
								capitalAccountTitle: { name: "" },
								interestAccountTitleId: { name: "" },
								ldAccountTitleId: { name: "" },
							}
					  }
					: this.projectSelect;

				// 不變更方案：維持原方案，名稱顯示「不變更方案」、利率維持原利率
				if (this.recordToEdit.newProjectCode === this.recordToEdit.oldProjectCode) {
					this.recordToEdit.newProjectName = "不變更方案";
					this.recordToEdit.newProjectRate = this.projectSelect.normalAnnualRate || "";
				} else {
					this.recordToEdit.newProjectName = this.projectSelect.name;
					this.recordToEdit.newProjectRate = this.projectSelect.normalAnnualRate;
				}
			},
			deep: true,
		},
	},
	methods: {
		calculateInfo() {
			let dateCalculate = $(".calculateBaseDate").val();
			if (!dateCalculate) {
				this.$message.closeAll();
				this.$message({
					type: "error",
					message: "尚未選擇結算基準日",
				});
				return;
			}

			dateCalculate = this.$toGeneralDate(dateCalculate);
			let url = API.coopLoanIou + "?action=getCalByDate";
			let form = new FormData();
			console.log(this.recordToEdit);
			form.append("iouNumber", this.recordToEdit.iouNumber);
			form.append("baseDate", dateCalculate);
			let thenCB = (json) => {
				this.iouInfo = json.resultData;
				this.formType[2].vif = true;
			};
			this.mAxiosPost(url, form, thenCB);
		},
		submitProject() {
			let url = API.coopLoanIouModify + "?action=submitProject";

			let date = $(".calculateBaseDate").val();

			let dataPost = new FormData();
			dataPost.append("id", this.recordToEdit.id);
			dataPost.append("calculateBaseDate", this.$toGeneralDate(date));
			dataPost.append("newProjectCode", this.recordToEdit.newProjectCode);
			dataPost.append("newProjectName", this.recordToEdit.newProjectName);
			dataPost.append("iouNumber", this.recordToEdit.iouNumber)
			dataPost.append(
				"interestAmountReduction",
				this.recordToEdit.interestAmountReduction
			);
			dataPost.append(
				"annualAmountReduction",
				this.recordToEdit.annualAmountReduction
			);

			const postCB = (json) => {
				this.showAjaxSuccessMsg();
				this.$emit("reflashWorkFlow", true);
			};

			this.mAxiosPost(url, dataPost, postCB);
		},
		viewProject() {
			if (!this.recordToEdit.newProjectCode) {
				this.$message.closeAll();
				this.$message({
					type: "error",
					message: "尚未選擇方案",
				});
				return;
			}
			this.dialogEdit = true;
		},
		chooseIou(data, row) {
			this.recordToEdit.iouNumber = row.iouNumber;
			this.recordToEdit.memberId = row.memberId;
			this.dialogEdit = false;
		},
		renderEnum(objectValue, enumName, isJson = false) {
			if (isJson) {
				objectValue = !objectValue ? [] : JSON.parse(objectValue);
				return objectValue
					.map((obj) => this.allEnum[enumName][obj.toString()])
					.join("、");
			}
			if (!objectValue) {
				objectValue = 0;
			}

			return !this.allEnum[enumName]
				? ""
				: this.allEnum[enumName][objectValue.toString()];
		},
		// 資料由父頁 LoanPlanChangeEdit 透過 props 帶入，不再自行打 API，避免重複請求
		bindData() {
			const enu = this.enumData;
			if (!enu || !enu.chooseProject) return;

			this.recordToEdit = Object.assign(
				{},
				this.recordToEdit,
				this.parentRecord
			);
			this.allEnum = enu;
			enu.chooseProject.forEach((project) => {
				this.chooseProjectList[project.code] = project;
			});

			const oldProjectCode = this.recordToEdit.oldProjectCode;
			// 隱藏與舊方案相同的真實選項，改以「不變更方案」表示（兩者等義）
			this.formType[3].options = enu.chooseProject
				.filter((project) => project.code !== oldProjectCode)
				.map((project) => {
					return {
						label: `${project.code} ${project.name}`,
						value: project.code,
					};
				});
			// 不變更方案：以原方案 code 作為 value，維持原方案與原利率，僅做減免
			this.formType[3].options.unshift({
				label: "不變更方案",
				value: oldProjectCode,
			});
		},
		goForm(item, index) {
			this.formList.find((key) => {
				if (key.label == item.label) {
					this.titleLabel = item.label;
					if (item.reviewInfo) {
						this.reviewInfo = {};
						this.reviewInfo = item.reviewInfo;
					}
					this.$router.push({
						name: `${key.name}`,
						params: {
							id: this.id,
						},
					});
				}
			});
		},
	},
};
</script>